<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div ref="totalRef" class="subpage">
    <Header v-if="$route.query.platform !== 'mini'" ref="navBarRef" title="康熙字典" :is-sub-page="true">
      <template v-slot:rightBtn>
        <span class="btn btn-share" @click="shareClick"></span>
      </template>
    </Header>
    <div ref="contentRef" style="display: flex; flex-direction: column;">
      <div class="search-container">
        <div style="padding-bottom: 25.4%; height: 0; margin: 20px 0 10px 0;">
          <img src="@/assets/images/backgrounds/bg-kxzd.png" alt="pic" class="bg-img" style="margin: 0 auto"/>
        </div>
        <form @submit.prevent="goSearch" action="javascript:return true">
          <cube-input ref="inputRef" class="search-input" v-model="firstName" placeholder="请输入汉字">
            <template v-slot:append>
              <img class="search-icon" :src="searchIcon" @click="goSearch"/>
            </template>
          </cube-input>
        </form>
      </div>
      <cube-scroll ref="scroll" style="flex: 1">
        <div class="dictionary">
          <template v-if="getDicMsg !== null">
            <div class="search-result">
              <div class="search-font">
                <span>{{ getDicMsg.text.trim() }}</span>
              </div>
              <div class="search-msg">
                <span class="phonetic">[{{ getDicMsg.pinyin.trim() }}]</span>
                <span class="simplified">
                <div>
                  总笔画:  {{ getDicMsg.stroke }}
                </div>
                <div class="tradition-font">
                  繁体字:  {{ getDicMsg.traditional.trim() }}
                </div>
                </span>
                <span class="traditional">康熙字典笔画( {{ getDicMsg.traditional.trim() + ':' + getDicMsg.traditionalStroke }} )</span>
              </div>
            </div>
            <SpaceHolder spaceheight="0"></SpaceHolder>
            <div class="search-detail">{{ getDicMsg.content }}</div>
          </template>
        </div>
      </cube-scroll>
    </div>
  </div>
</template>

<script>
import SpaceHolder from '../components/SpaceHolder'
import Header from '@/components/Header'

import { queryKangxiDic } from '@/api/test'
// import { queryKangxiDic, shareTest } from '@/api/test'

export default {
  name: 'Dictionary',
  components: {
    SpaceHolder,
    Header
  },
  data () {
    return {
      firstName: '',
      searchIcon: require('@/assets/images/icons/icon-search.png'),
      getDicMsg: null,
      testId: null
    }
  },
  methods: {
    goSearch () {
      this.$refs.inputRef.blur()

      const reg = /^[\u4e00-\u9fa5]$/
      const re = new RegExp(reg)
      if (!re.test(this.firstName)) {
        this.$createToast({
          txt: '请输入单个汉字',
          type: 'txt'
        }).show()
        return
      }

      const loadingToast = this.$createToast({
        time: 0
      }).show()

      queryKangxiDic({
        searchText: this.firstName
      }).then((res) => {
        loadingToast.hide()

        if (JSON.stringify(res.data) === '{}') {
          this.$createToast({
            txt: '查无此字',
            type: 'txt'
          }).show()

          return
        }
        this.testId = res.data.testId
        this.getDicMsg = res.data

        this.$refs.scroll.scrollTo(0, 0, 1, '')
      })
    },
    shareClick () {
      console.log('康熙 share')
      var json = {
        typeCode: '0'
      }
      if (this.testId) {
        json['testId'] = this.testId
      }

      console.log(process.env.VUE_APP_SHARE_URL + '/dictionary')
      this.$dfzhJsBridge.share({
        url: process.env.VUE_APP_SHARE_URL + '/dictionary',
        title: '东方智汇康熙字典',
        description: ' '
      })
    }
  },
  mounted () {
    document.title = '康熙字典'
    if (this.$route.query && this.$route.query.token) {
      this.$store.commit('setInfo', { token: this.$route.query.token })
    }

    this.$nextTick(() => {
      const navBarHeight = this.$refs.navBarRef ? this.$refs.navBarRef.$el.clientHeight : 0
      this.$refs.contentRef.style.height = (this.$refs.totalRef.clientHeight - navBarHeight) + 'px'
    })
  }
}
</script>

<style lang="stylus" scoped>
.subpage
  background url("~@/assets/images/backgrounds/bg.png") no-repeat center
  background-size 100% 100%
  .search-container
    padding 12px 15px
    .search-input
      border 1px solid #874DD5
      border-radius 8px
      overflow: auto;
    /deep/.cube-input-field
      background-color transparent
      border-radius 8px
    .search-icon
      width 19px
      height 19px
      margin-right 15px
.dictionary
  padding 10px 15px
  .search-result
    height 120px
    background #FFFFFF
    padding 10px
    display flex
    .search-font
      display flex
      justify-content center
      align-items center
      width 36.2%
      margin 5px
      background url("~@/assets/images/icons/icon-mzg.png") no-repeat center
      background-size 90px 90px
      span
        flex-grow 1
        font-size 60px
        font-weight 400
        color #545454
    .search-msg
      display flex
      flex-direction column
      width 63.8%
      margin 5px
      padding 8px
      span
        display flex
        justify-content flex-start
        flex-grow 1
        max-height 33.3%
      .phonetic
        font-size 18px
        font-weight 400
        color #874DD5
      .simplified
        display flex
        div
          flex-grow 1
          display flex
          justify-content flex-start
          align-items center
          font-size 15px
          font-weight 400
          color #9d9d9d
        .tradition-font {
          justify-content flex-end
        }
      .traditional
          flex-grow 1
          display flex
          justify-content flex-start
          align-items center
          font-size 18px
          font-weight 400
          color #874DD5
  .search-detail
    text-align start
    padding 22px
    font-size 15px
    font-weight 400
    line-height 20px
    color #545454
    background #fff
</style>

<style lang="stylus">
body
  background-color #EFE9E0
</style>
